// Newsletter signup modal. Opens on any [data-ws-newsletter-open] click; closes
// on the × button, a backdrop click, or Esc (native <dialog>). Auto-opens after
// a form submit so the visitor sees the success/error message.
if (!customElements.get('ws-newsletter-popup')) {
  customElements.define(
    'ws-newsletter-popup',
    class WsNewsletterPopup extends HTMLElement {
      #abort = null;

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.#abort = new AbortController();
        const { signal } = this.#abort;

        // Open triggers can live anywhere on the page (e.g. a banner button).
        document.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-ws-newsletter-open]')) {
              event.preventDefault();
              this.open();
            }
          },
          { signal }
        );

        // Close on the × button or a click on the backdrop (the dialog element
        // itself; content sits inside __inner so it never matches).
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-ws-newsletter-close]') || event.target === this.dialog) {
              this.close();
            }
          },
          { signal }
        );

        // Reopen after a submit round-trip to reveal the confirmation message.
        if (this.querySelector('[data-ws-newsletter-posted]')) this.open();
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }
    }
  );
}
